'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setUIProperty = function setUIProperty(schema, field, property, value) {
  var clonedSchema = _ramda2.default.clone(schema);

  if (clonedSchema[field]) {
    clonedSchema[field][property] = value;
  }

  return clonedSchema;
};

exports.default = setUIProperty;


//////////////////
// WEBPACK FOOTER
// ./~/form-service/frontend/lib/utils/setUIProperty.js
// module id = 1129
// module chunks = 5